import { styled } from '@mui/material'
import { Loading } from '$common/loading/chat-loading'

const Root = styled('div')<{ 'data-is-inline'?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  box-sizing: border-box;
  border-radius: 24px;
  background-color: #0000004d;
  left: 50%;
  top: 15px;

  &[data-is-inline='true'] {
    position: absolute;
    height: 29px;
    transform: translateX(-50%);
  }
`

export function MessageListLoading({
  isInline,
  offset,
}: {
  isInline?: boolean
  offset?: number
}) {
  return (
    <Root
      data-is-inline={isInline}
      style={{
        padding: `${isInline ? 8 : 15}px 30px`,
        margin: `${isInline ? 16 + (offset || 0) : 0}px auto`,
      }}
    >
      <Loading color="white" />
    </Root>
  )
}

MessageListLoading.defaultProps = { isInline: false, offset: 0, edge: false }
